var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ padding: _vm.$route.meta.notNeedPadding ? '0' : '0px  11px' ,paddingBottom: _vm.$route.meta.notShowTabBar ? '0' :'80px'}),attrs:{"id":"app"}},[(_vm.$route.meta.notShowTabBar)?_c('section',[_c('router-view')],1):_c('section',[_c('router-view'),_c('Tabbar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }